// 热门推荐
export const HOT_RECOMMEND_LIMIT = 8

// 一页条数
export const PER_PAGE_NUMBER = 35

// 默认进入播放的第一首歌
export const DEFAULT_SONG = 5221167

// 排行榜
export const TOP_UP_LIST_ID = 19723756
export const TOP_NEW_LIST_ID = 3779629
export const TOP_ORIGIN_LIST_ID = 2884035
